import {
    LOAD_SERVER_LIST,
    LOAD_SERVER_LIST_SUCCESS,
    LOAD_SERVER_LIST_ERROR,
    CLEAR_SERVER_LIST,
} from 'constants/ActionTypes';
import { Core } from 'managers';
import { createAction } from 'actions/utils';

export function getList(list) {
    return (dispatch, getState) => {
        // Store version
        const serverList = getState().serverList[list];
        const { authentication } = getState();
        const { user } = authentication;
        let { lang } = user;
        lang = lang ? lang.toUpperCase() : 'EN';

        if (!serverList) {
            dispatch(createAction(LOAD_SERVER_LIST, { list }));
            return Core.serverListManager.getList(list, lang).then(
                (data) => {
                    dispatch(createAction(LOAD_SERVER_LIST_SUCCESS, { list, data }));
                },
                (error) => {
                    dispatch(createAction(LOAD_SERVER_LIST_ERROR, { list, error }));
                    throw error;
                },
            );
        }
        return serverList;
    };
}

export function clearList(list) {
    return (dispatch) => {
        dispatch(createAction(CLEAR_SERVER_LIST, { list }));
    };
}
